import React from 'react';
import FormGroup from "../Form/FormGroup";
import Input from "../Input/Input";
import Label from "../Label/Label";

var RadioGroup = function RadioGroup(_ref) {
  var options = _ref.options,
      _onChange = _ref.onChange,
      selected = _ref.selected,
      name = _ref.name;
  return /*#__PURE__*/React.createElement(FormGroup, null, options.map(function (option) {
    return /*#__PURE__*/React.createElement(FormGroup, {
      check: true,
      key: option.value
    }, /*#__PURE__*/React.createElement(Label, {
      check: true
    }, /*#__PURE__*/React.createElement(Input, {
      type: "radio",
      checked: selected === option.value,
      onChange: function onChange(e) {
        return e.target.checked && _onChange(option.value);
      },
      name: name
    }), ' ', option.label));
  }));
};

RadioGroup.displayName = "RadioGroup";
RadioGroup.displayName = 'RadioGroup';
export default RadioGroup;